// invoiceValidationSchema.ts

import { Offer } from "../../types/offerForm";
import { ValidationSchema } from "../validationForm";
import { isValidDecimal, validateIBAN, validateOIB } from "../validator";


export const offerValidationSchema: ValidationSchema<Offer> = {
  iban: [validateIBAN],
  toOib: [validateOIB],
  fromOib: [validateOIB],
  taxRate: [isValidDecimal],
  discountRate: [isValidDecimal],  
};
